import React from "react";

import ACIconWrapper, { ACIconProps } from "./ACIconWrapper";

export default function ACScopeIcon(props: ACIconProps) {
  return <ACIconWrapper component={IconSvg} {...props} />;
}

const IconSvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4C12.4142 4 12.75 4.33579 12.75 4.75V5.03971C16.0169 5.38769 18.6123 7.98308 18.9603 11.25H19.25C19.6642 11.25 20 11.5858 20 12C20 12.4142 19.6642 12.75 19.25 12.75H18.9603C18.6123 16.0169 16.0169 18.6123 12.75 18.9603V19.25C12.75 19.6642 12.4142 20 12 20C11.5858 20 11.25 19.6642 11.25 19.25V18.9603C7.98308 18.6123 5.38769 16.0169 5.03971 12.75H4.75C4.33579 12.75 4 12.4142 4 12C4 11.5858 4.33579 11.25 4.75 11.25H5.03971C5.38769 7.98308 7.98308 5.38769 11.25 5.03971V4.75C11.25 4.33579 11.5858 4 12 4ZM6.55071 12.75H9.25C9.66421 12.75 10 12.4142 10 12C10 11.5858 9.66421 11.25 9.25 11.25H6.55071C6.88307 8.81246 8.81246 6.88307 11.25 6.55071V9.25C11.25 9.66421 11.5858 10 12 10C12.4142 10 12.75 9.66421 12.75 9.25V6.55071C15.1875 6.88307 17.1169 8.81246 17.4493 11.25H14.75C14.3358 11.25 14 11.5858 14 12C14 12.4142 14.3358 12.75 14.75 12.75H17.4493C17.1169 15.1876 15.1876 17.1169 12.75 17.4493V14.75C12.75 14.3358 12.4142 14 12 14C11.5858 14 11.25 14.3358 11.25 14.75V17.4493C8.81246 17.1169 6.88307 15.1876 6.55071 12.75Z"
        fill="currentColor"
      />
    </svg>
  );
};
